export interface ICopilotSuggestion {
  suggestionType: string;
  eventUuid: string | null;
  name: string;
  type: string;
  description: string;
  status: string;
  dueDate: Date;
  id: number;
}

export interface CopilotSearchResult {
  pageContent: string;
  metadata: {
    threadUuid: number;
    organizationUuid: number;
    fileUuid: number | null;
    name: string;
    fullName: string;
    status: string;
    description: string | null;
    createdAt: Date;
  };
}

export enum ECopilotSuggestionTypes {
  CREATE = 'CREATE',
  MODIFY = 'MODIFY',
}

export enum SuggestionAction {
  ACCEPT = 'ACCEPT',
  EDIT = 'EDIT',
  DISMISS = 'DISMISS',
}
